import { Typography } from '@mui/material';
import { CasRenderRelativeDateTime } from 'src/compass/shared/components';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';

export function RenderLastActivity({ row, column }: ICasRenderCellProps) {
  return (
    <>
      <Typography variant="body2">{row.lastActivity}</Typography>
      <Typography variant="caption">{CasRenderRelativeDateTime({ row, column })} </Typography>
    </>
  );
}
